module.exports = __webpack_public_path__ + "img/logo.8cb4f65c.png";